<div class="modal" id="solution">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Best practice solution</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="svg" [innerHTML]="lsg"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary">Schließen</button>
      </div>
    </div>
  </div>
</div>



<!--<div class="card text-center">style="width: 50;"
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <a class="nav-link active" href="#">Aufgabe</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Musterlösung</a>
        </li>
      </ul>
    </div>
  <div class="card-body">
    <div class="container">
        <div class="row justify-content-md-left">
            <div class="col-md-auto">
              Hello
            </div>
            <div class="col-sm">
                
            </div>
        </div>
  </div>
</div>
-->